(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[908],{

/***/ "3Uf/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Twitter", function() { return Twitter; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Twitter = function Twitter(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M27.0045 7.55625C26.1233 7.95 25.1715 8.2125 24.1778 8.3295C25.1948 7.71975 25.9733 6.7545 26.343 5.60625C25.3913 6.16875 24.3368 6.58125 23.2162 6.80175C22.3162 5.8455 21.0368 5.25 19.6208 5.25C16.902 5.25 14.6985 7.4535 14.6985 10.1722C14.6985 10.5562 14.7405 10.9313 14.8252 11.2928C10.7332 11.0865 7.10475 9.12675 4.677 6.14625C4.25475 6.873 4.01175 7.72125 4.01175 8.62125C4.01175 10.3275 4.87875 11.8365 6.201 12.7185C5.39475 12.6953 4.63575 12.4703 3.96975 12.1042C3.96975 12.123 3.96975 12.1463 3.96975 12.165C3.96975 14.5507 5.667 16.5435 7.9215 16.9928C7.509 17.1052 7.07325 17.166 6.62325 17.166C6.3045 17.166 6 17.133 5.6955 17.0767C6.324 19.0312 8.14275 20.4563 10.2937 20.499C8.60625 21.8205 6.4875 22.6087 4.17675 22.6087C3.7785 22.6087 3.38925 22.5855 3 22.5382C5.18475 23.94 7.7715 24.7507 10.5517 24.7507C19.608 24.7507 24.5625 17.2463 24.5625 10.74C24.5625 10.5247 24.558 10.3133 24.5483 10.1025C25.509 9.41325 26.3438 8.54625 27.0045 7.557V7.55625Z"
  }));
};

/***/ })

}]);